var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_22172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98047 1C6.596 1 5.24262 1.41054 4.09148 2.17971C2.94034 2.94888 2.04313 4.04213 1.51332 5.32122C0.983502 6.6003 0.844878 8.00776 1.11497 9.36563C1.38507 10.7235 2.05176 11.9708 3.03072 12.9497C4.00969 13.9287 5.25697 14.5954 6.61484 14.8655C7.97271 15.1356 9.38017 14.997 10.6593 14.4672C11.9383 13.9373 13.0316 13.0401 13.8008 11.889C14.5699 10.7378 14.9805 9.38447 14.9805 8C14.9805 6.14348 14.243 4.36301 12.9302 3.05025C11.6175 1.7375 9.83699 1 7.98047 1ZM7.98047 4C8.12881 4 8.27381 4.04399 8.39715 4.1264C8.52049 4.20881 8.61662 4.32594 8.67338 4.46299C8.73015 4.60003 8.745 4.75083 8.71606 4.89632C8.68712 5.0418 8.61569 5.17544 8.5108 5.28033C8.40591 5.38522 8.27227 5.45665 8.12679 5.48559C7.9813 5.51453 7.8305 5.49968 7.69346 5.44291C7.55641 5.38614 7.43928 5.29001 7.35687 5.16668C7.27446 5.04334 7.23047 4.89834 7.23047 4.75C7.23047 4.55109 7.30949 4.36032 7.45014 4.21967C7.59079 4.07902 7.78156 4 7.98047 4ZM9.98047 12.0625H5.98047V10.9375H7.41797V8.0625H6.48047V6.9375H8.54297V10.9375H9.98047V12.0625Z",
    fill: "#7940E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_22172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.0191,
    height: 16,
    fill: "white",
    transform: "translate(0.980469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dea304496a87fe105235100e3bbe700c.svg";
export { ForwardRef as ReactComponent };